import svgPaths from "../imports/SidebarIconPaths";

// SVG Component helpers
function Mp() {
  return (
    <div className="absolute bottom-0 left-[6.52%] right-[6.5%] top-0" data-name="MP4">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 27 30">
        <g id="MP4">
          <g id="File">
            <g id="Vector"></g>
            <g id="Group">
              <path d={svgPaths.p130fc100} fill="#7035C4" id="Vector_2" />
              <path d={svgPaths.p2dc20600} fill="#7035C4" id="Vector_3" />
            </g>
          </g>
          <path d={svgPaths.p2e01ad00} fill="#7035C4" id="Vector_4" />
        </g>
      </svg>
    </div>
  );
}

function Eml() {
  return (
    <div className="absolute inset-[58.75%_39%_26.45%_21.34%]" data-name="EML-2">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 12 5">
        <g id="EML-2">
          <path d={svgPaths.p2ca53d80} fill="white" id="Vector" />
          <path d={svgPaths.p1e854a70} fill="white" id="Vector_2" />
          <path d={svgPaths.p1283bc00} fill="white" id="Vector_3" />
        </g>
      </svg>
    </div>
  );
}

export function EmailIcon() {
  return (
    <div className="overflow-clip relative shrink-0 size-[33.291px]">
      <div className="absolute bottom-0 left-[6.52%] right-[6.5%] top-0">
        <Mp />
      </div>
      <Eml />
    </div>
  );
}

function Pdf() {
  return (
    <div className="absolute bottom-0 left-[6.52%] right-[6.5%] top-0" data-name="PDF">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 27 30">
        <g id="PDF">
          <g id="File">
            <g id="Vector"></g>
            <g id="Group">
              <path d={svgPaths.p37a9f000} fill="#7035C4" id="Vector_2" />
              <path d={svgPaths.p245f2d00} fill="#7035C4" id="Vector_3" />
            </g>
          </g>
          <path d={svgPaths.p177ea780} fill="#7035C4" id="Vector_4" />
          <g id="Group_2">
            <path d={svgPaths.p1f026240} fill="white" id="Vector_5" />
            <path d={svgPaths.pef5ecf0} fill="white" id="Vector_6" />
            <path d={svgPaths.p22493100} fill="white" id="Vector_7" />
          </g>
        </g>
      </svg>
    </div>
  );
}

export function PdfIcon() {
  return (
    <div className="overflow-clip relative shrink-0 size-[33.291px]">
      <Pdf />
    </div>
  );
}

function Csv() {
  return (
    <div className="absolute bottom-0 left-[6.52%] right-[6.5%] top-0" data-name="CSV">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 27 30">
        <g id="CSV">
          <g id="File">
            <g id="Vector"></g>
            <g id="Group">
              <path d={svgPaths.p8a7b8c0} fill="#7035C4" id="Vector_2" />
              <path d={svgPaths.p22d54a00} fill="#7035C4" id="Vector_3" />
            </g>
          </g>
          <path d={svgPaths.p4e2ba00} fill="#7035C4" id="Vector_4" />
          <g id="Group_2">
            <path d={svgPaths.pe8f1d00} fill="white" id="Vector_5" />
            <path d={svgPaths.p18bb8500} fill="white" id="Vector_6" />
            <path d={svgPaths.p2642f200} fill="white" id="Vector_7" />
          </g>
        </g>
      </svg>
    </div>
  );
}

export function CsvIcon() {
  return (
    <div className="overflow-clip relative shrink-0 size-[33.291px]">
      <Csv />
    </div>
  );
}

function Docx() {
  return (
    <div className="absolute bottom-0 left-[6.52%] right-[6.5%] top-0" data-name="DOCX">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 27 30">
        <g id="DOCX">
          <g id="File">
            <g id="Vector"></g>
            <g id="Group">
              <path d={svgPaths.p130fc100} fill="#7035C4" id="Vector_2" />
              <path d={svgPaths.p1599f900} fill="#7035C4" id="Vector_3" />
            </g>
          </g>
          <path d={svgPaths.p2be69000} fill="#7035C4" id="Vector_4" />
          <g id="Group_2">
            <path d={svgPaths.p12808900} fill="white" id="Vector_5" />
            <path d={svgPaths.p22eb5880} fill="white" id="Vector_6" />
            <path d={svgPaths.p2a810080} fill="white" id="Vector_7" />
            <path d={svgPaths.p2af56900} fill="white" id="Vector_8" />
          </g>
        </g>
      </svg>
    </div>
  );
}

export function DocxIcon() {
  return (
    <div className="overflow-clip relative shrink-0 size-[33.291px]">
      <Docx />
    </div>
  );
}

function Mp4() {
  return (
    <div className="absolute bottom-0 left-[6.52%] right-[6.5%] top-0" data-name="MP4">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 27 30">
        <g id="MP4">
          <g id="File">
            <g id="Vector"></g>
            <g id="Group">
              <path d={svgPaths.p130fc100} fill="#7035C4" id="Vector_2" />
              <path d={svgPaths.p2dc20600} fill="#7035C4" id="Vector_3" />
            </g>
          </g>
          <path d={svgPaths.p2e01ad00} fill="#7035C4" id="Vector_4" />
          <g id="Group_2">
            <path d={svgPaths.p17521380} fill="white" id="Vector_5" />
            <path d={svgPaths.pb587200} fill="white" id="Vector_6" />
            <path d={svgPaths.p10639840} fill="white" id="Vector_7" />
          </g>
        </g>
      </svg>
    </div>
  );
}

export function Mp4Icon() {
  return (
    <div className="overflow-clip relative shrink-0 size-[33.291px]">
      <Mp4 />
    </div>
  );
}

function Xlsx() {
  return (
    <div className="absolute bottom-0 left-[6.52%] right-[6.5%] top-0" data-name="XLSX">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 27 30">
        <g id="XLSX">
          <g id="File">
            <g id="Vector"></g>
            <g id="Group">
              <path d={svgPaths.p8a7b8c0} fill="#7035C4" id="Vector_2" />
              <path d={svgPaths.p22d54a00} fill="#7035C4" id="Vector_3" />
            </g>
          </g>
          <path d={svgPaths.p4e2ba00} fill="#7035C4" id="Vector_4" />
          <g id="Group_2">
            <path d={svgPaths.pe8f1d00} fill="white" id="Vector_5" />
            <path d={svgPaths.p18bb8500} fill="white" id="Vector_6" />
            <path d={svgPaths.p2642f200} fill="white" id="Vector_7" />
          </g>
        </g>
      </svg>
    </div>
  );
}

export function XlsxIcon() {
  return (
    <div className="overflow-clip relative shrink-0 size-[33.291px]">
      <Xlsx />
    </div>
  );
}

function Txt() {
  return (
    <div className="absolute bottom-0 left-[6.52%] right-[6.5%] top-0" data-name="TXT">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 27 30">
        <g id="TXT">
          <g id="File">
            <g id="Vector"></g>
            <g id="Group">
              <path d={svgPaths.p130fc100} fill="#7035C4" id="Vector_2" />
              <path d={svgPaths.p1599f900} fill="#7035C4" id="Vector_3" />
            </g>
          </g>
          <path d={svgPaths.p2be69000} fill="#7035C4" id="Vector_4" />
        </g>
      </svg>
    </div>
  );
}

export function TxtIcon() {
  return (
    <div className="overflow-clip relative shrink-0 size-[33.291px]">
      <Txt />
    </div>
  );
}

function Avi() {
  return (
    <div className="absolute bottom-0 left-[6.52%] right-[6.5%] top-0" data-name="AVI">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 27 30">
        <g id="AVI">
          <g id="File">
            <g id="Vector"></g>
            <g id="Group">
              <path d={svgPaths.p130fc100} fill="#7035C4" id="Vector_2" />
              <path d={svgPaths.p2dc20600} fill="#7035C4" id="Vector_3" />
            </g>
          </g>
          <path d={svgPaths.p2e01ad00} fill="#7035C4" id="Vector_4" />
          <g id="Group_2">
            <path d={svgPaths.p17521380} fill="white" id="Vector_5" />
            <path d={svgPaths.pb587200} fill="white" id="Vector_6" />
            <path d={svgPaths.p10639840} fill="white" id="Vector_7" />
          </g>
        </g>
      </svg>
    </div>
  );
}

export function AviIcon() {
  return (
    <div className="overflow-clip relative shrink-0 size-[33.291px]">
      <Avi />
    </div>
  );
}

function Msg() {
  return (
    <div className="absolute bottom-0 left-[6.52%] right-[6.5%] top-0" data-name="MSG">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 27 30">
        <g id="MSG">
          <g id="File">
            <g id="Vector"></g>
            <g id="Group">
              <path d={svgPaths.p130fc100} fill="#7035C4" id="Vector_2" />
              <path d={svgPaths.p2dc20600} fill="#7035C4" id="Vector_3" />
            </g>
          </g>
          <path d={svgPaths.p2e01ad00} fill="#7035C4" id="Vector_4" />
        </g>
      </svg>
    </div>
  );
}

export function MsgIcon() {
  return (
    <div className="overflow-clip relative shrink-0 size-[33.291px]">
      <div className="absolute bottom-0 left-[6.52%] right-[6.5%] top-0">
        <Msg />
      </div>
      <Eml />
    </div>
  );
}

export function ZipIcon() {
  return (
    <div className="relative shrink-0 size-[33.291px] flex items-center justify-center">
      <svg width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 0C1.34 0 0 1.34 0 3V27C0 28.66 1.34 30 3 30H24C25.66 30 27 28.66 27 27V8L19 0H3Z" fill="#7035C4" opacity="0.15"/>
        <path d="M19 0L27 8H22C20.34 8 19 6.66 19 5V0Z" fill="#7035C4" opacity="0.3"/>
        <rect x="11" y="2" width="5" height="3" rx="0.5" fill="#7035C4" opacity="0.6"/>
        <rect x="11" y="6" width="5" height="3" rx="0.5" fill="#7035C4" opacity="0.6"/>
        <rect x="11" y="10" width="5" height="3" rx="0.5" fill="#7035C4" opacity="0.6"/>
        <rect x="11" y="14" width="5" height="3" rx="0.5" fill="#7035C4" opacity="0.6"/>
        <rect x="10" y="18" width="7" height="8" rx="1" fill="#7035C4" opacity="0.8"/>
        <circle cx="13.5" cy="21" r="1.5" fill="white"/>
        <text x="5" y="28" fontSize="6" fontWeight="bold" fill="#7035C4" opacity="0.9">ZIP</text>
      </svg>
    </div>
  );
}

/** A file icon with a short type label, for types without their own artwork
 *  (spreadsheets, images, web pages; sc-10995). */
export function LabeledFileIcon({ label }: { label: string }) {
  return (
    <div className="relative shrink-0 size-[33.291px] flex items-center justify-center">
      <svg width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M3 0C1.34 0 0 1.34 0 3V27C0 28.66 1.34 30 3 30H24C25.66 30 27 28.66 27 27V8L19 0H3Z" fill="#7035C4" opacity="0.15"/>
        <path d="M19 0L27 8H22C20.34 8 19 6.66 19 5V0Z" fill="#7035C4" opacity="0.3"/>
        <rect x="1.5" y="17" width="24" height="9" rx="1.5" fill="#7035C4"/>
        <text x="13.5" y="24" fontSize={label.length > 3 ? 5.5 : 6.5} fontWeight="bold" fill="white" textAnchor="middle">{label}</text>
      </svg>
    </div>
  );
}
